import React from 'react';

import PropTypes from 'prop-types';

import usePromoTracking from '~/shared/utils/usePromoTracking';
import { ListViewedProvider as PromoListViewedProvider } from '~/techstyle-shared/react-components';

const PromoTrackingWrapper = ({ children, root }) => {
  const { onPromoViewed } = usePromoTracking();
  return (
    <PromoListViewedProvider onItemViewed={onPromoViewed} root={root}>
      {children}
    </PromoListViewedProvider>
  );
};

PromoTrackingWrapper.propTypes = {
  children: PropTypes.node,
  /**
   * Optional root element for the IntersectionObserver.
   * Use this when tracking elements inside floating menus/dropdowns.
   */
  root: PropTypes.object,
};

export default PromoTrackingWrapper;
